module.exports = __webpack_public_path__ + "img/B10.d9170199.png";